import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateDon } from '../../../actions/Activites/Dons';
import { baseUrl } from '../../../nametitle/dataUrl';

const ModalAddDon = () => {
  const navigate = useNavigate("");

  const [title, settitle] = useState("");
  const [date, setdate] = useState("");
  const [description, setdescription] = useState("");
  const [coverPicture, setcoverPicture] = useState("");
  const [video, setvideo] = useState("");
 

  const [Loading, setLoading] = useState();
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  }
  function uploadSingleImage(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChange = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleImage(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };


  // *************************************************** Video
  function uploadSingleVideo(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setvideo(res.data); alert("vidéo uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChangeVideo = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleVideo(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };

  return (
    <div className=" modal fade " id="addModal" tabIndex="-2" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content rounded-0">
          <div className="modal-header relative">
            <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
              Ajouter un projet de don
            </h6>
            <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
          </div>
          <div className="modal-body container flex justify-center">
            <div className="flex justify-center row g-8">
              <div className="col-lg-9">
                <form onSubmit={(e) => {
                  e.preventDefault();
                  CreateDon(title, coverPicture, description,date, video, navigate);
                }}>
                  <div className="row g-3">
                    <div className="col-12">
                      <input type="text" required value={title} onChange={(e) => { settitle(e.target.value) }} className="form-control bg-light border-0 px-4 py-1 translatable" placeholder="titre" style={{ height: "40px" }} />
                    </div>
                    <div className="col-12 flex">
                    <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>image</label>
                      <input type="file" onChange={HandleFileInputChange} accept=".JPG,.JPEG,.PNG" required className="form-control bg-light border-0 px-4" placeholder="image" style={{ height: "40px" }} />
                      {coverPicture && (<img src={`${coverPicture}`} className="h-[50px] h-[50px]" />)}
                    </div>
                    <div className="col-12 flex">
                    <label className="form-control border-0 px-4" style={{ height: "40px" }}>vidéo</label>
                      <input type="file" onChange={HandleFileInputChangeVideo} accept=".MP4" required className="form-control bg-light border-0 px-4 translatable" placeholder="image" style={{ height: "40px" }} />
                      {video  && (<p className="text-green-600 translatable">Vidéo télécharger</p>)}
                    </div>
                    <div className="col-12 flex">
                      <label className="form-control border-0 px-4 translatable" style={{ height: "40px" }}>date</label>
                      <input type="date" value={date} onChange={(e) => { setdate(e.target.value) }} required className="form-control bg-light border-0 px-4 translatable" placeholder="Numéro de téléphone" style={{ height: "40px" }} />
                    </div>
                    <div className="col-12">
                      <textarea required value={description} onChange={(e) => { setdescription(e.target.value) }} className="form-control bg-light border-0 px-4 translatable" placeholder="description du don ..../donne par ../but../" style={{ height: "155px" }} />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Ajouter</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalAddDon;
